const measurableModel = require("../../../measurable/models/measurable");

var diagramConfiguration = {
  fontSize: 13,
  ratio: 0.733333333,
  calculateCellWidth: function() {
    return this.fontSize * 0.733333333;
  },
  calculateCellHeight: function() {
    return (this.fontSize / this.fontSize) * this.fontSize;
  },

  calculateCellWidthBasedOnFontSize: function(fontSize) {
    return fontSize * 0.733333333;
  },
  findPortColorOnCategories: function(categories, portClass) {
    for (let category of categories) {
      if (category.name === portClass && category.data && category.data.color) {
          return category.data.color;
      }
      if (category.children && Array.isArray(category.children)) {
        let color = this.findPortColorOnCategories(category.children, portClass);
        if (color) {
          return color; 
        }
      }
    }
    return null; // Return null if not found
  },
  findPortColor: function (portClass) {
    let color = this.findPortColorOnCategories(measurableModel.measurableClassTree.categories, portClass);
    return color || '#ffffff';
  },
  findLinkDashArray: function(linkClass) {
    var foundLinkClass = {};
    this.findLinkDashArrayOnTree(linkClass, foundLinkClass);
    let arrayDashPattern = foundLinkClass.dashPattern ? foundLinkClass.dashPattern.split(",").map(Number) : undefined;
    return arrayDashPattern;
  },
  findLinkDashArrayOnTree: function(linkClass, foundLinkClass) {
    for (let category of measurableModel.measurableClassTree.categories) {
      if (category.name === linkClass && !foundLinkClass.dashPattern) {
          if (category.data && category.data.dashPattern) {
            foundLinkClass.dashPattern = category.data.dashPattern;
            foundLinkClass.dashPatternFrom = category.name;
          } else {
            if (category.parent) {
              this.findLinkDashArrayOnTree(category.parent, foundLinkClass);  
            }
          }
      }
      if (category.children && Array.isArray(category.children) && !foundLinkClass.dashPattern) {
        this.findLinkDashArrayOnCategories(category.children, linkClass, foundLinkClass);
      }
    }
  },
  findLinkDashArrayOnCategories: function(categories, linkClass, foundLinkClass) {
    for (let category of categories) {
      if (category.name === linkClass && !foundLinkClass.dashPattern) {
          if (category.data && category.data.dashPattern) {
            foundLinkClass.dashPattern = category.data.dashPattern;
            foundLinkClass.dashPatternFrom = category.name;
          } else {
            if (category.parent) {
              this.findLinkDashArrayOnTree(category.parent, foundLinkClass);  
            }
          }
      }
      if (category.children && Array.isArray(category.children) && !foundLinkClass.dashPattern) {
        this.findLinkDashArrayOnCategories(category.children, linkClass, foundLinkClass);
      }
    }
  }

}



module.exports = diagramConfiguration;